export enum PermissionEnum {
  ManageShifts = 'manageShift',
  ManageBonus = 'manageBonus',
  ManageRoles = 'manageRoles',
  PaymentAccess = 'paymentAccess',
  MessageWorker = 'messageWorker',
  WorkTimeAdjustment = 'workTimeAdjustment',
  ManageWorker = 'manageWorker',
  RequestSpecificWorker = 'requestSpecificWorker',
}
